import React from "react"
import SignInPage from "../pages/SignInPage"
import { initReactApp } from "../utils/init"

initReactApp(<SignInPage/>)
